import { render, staticRenderFns } from "./Museum.vue?vue&type=template&id=15893498&scoped=true"
import script from "./Museum.vue?vue&type=script&lang=ts"
export * from "./Museum.vue?vue&type=script&lang=ts"
import style0 from "./Museum.vue?vue&type=style&index=0&id=15893498&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15893498",
  null
  
)

export default component.exports